<template #modalBody>
    <div>
        <div class="forms">
            <b-row>
                <b-col class="form-item">
                    <label for="r_name"
                           class="textfield-with">
                        {{ $t('POLICY.RULE.TITLE') }}
                        <span class="icon-required">
                            {{ $t('COMMON.FIELD_REQUIRE') }}
                        </span>
                    </label>
                    <input
                        ref="input_title" type="text" id="r_name"
                        :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                        class="text-field"
                        :data-invalid="invalidRuleTitle"
                        v-model="rule.transTitl"
                        @input="changeTitle"
                        @keyup="checkRuleTitle"
                    >
                    <p class="invalid-message" v-if="invalidRuleTitle">
                        {{ invalidRuleTitleMsg }}
                    </p>
                </b-col>
            </b-row>
            <!-- 설명 -->
            <b-row>
                <b-col class="form-item mt-5">
                    <label for="r_desc" class="textfield-with">{{ $t('LABEL.DESCRIPTION') }}</label>
                    <textarea
                        id="r_desc" class="textarea"
                        :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                        :invalid="invalidRuleDesc ? true : null"
                        v-model="rule.transDesc"
                        @input="changeDescription"
                        @focusout="isInvalidRuleDesc"/>
                    <p class="invalid-message" v-if="invalidRuleDesc">
                        {{ $t('SETTING.WHITELIST.ERROR.MAX', {'cnt': '4000'}) }}</p>
                </b-col>
            </b-row>
            <!-- 카테고리 레이블 -->
            <b-row>
                <b-col class="form-item mt-5">
                    <label class="textfield-with">{{ $t('POLICY.RULE.CATEGORY_LABEL') }} <span
                        class="icon-required">{{ $t('COMMON.FIELD_REQUIRE') }}</span></label>
                    <select-box-multi
                        select-id="rule-select-ctg_1"
                        select-class="type-tagging"
                        place-holder="FILTER.SELECT_CATEGORY_PLEASE"
                        :use-labels="true"
                        :use-translate="true"
                        :select-box-options="getCtgFilterOptions"
                        :select-box-value="rule.ctgLabel || rawRule.ctgLabel"
                        :data-invalid="invalidRuleCtgLabel"
                        @onSelectChange="changeCategory"
                    />
                    <p class="invalid-message" v-if="invalidRuleCtgLabel">
                        {{ $t('POLICY.RULE.INVALID.CATEGORY_LABEL') }}
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="form-item popout-layer mt-5">
                    <label class="textfield-with">{{ $t('LABEL.SEVERITY') }}
                        <span class="icon-required">{{ $t('COMMON.FIELD_REQUIRE') }}</span>
                    </label>
                    <select-box-single
                        select-id="select_svrty_1"
                        select-class="type-single severity-clazz"
                        :use-translate="true"
                        :select-box-options="constants.SEVERITY_OPTIONS"
                        :select-box-value="rule.svrty"
                        @onSelectChange="changeSeverity"
                    />
                </b-col>
            </b-row>
        </div>
        <b-row class="mt-5 add-rule-radio">
            <b-col>
                <BaseRadioButtons
                    :options="ASSESSMENT_OPTIONS"
                    :selectedOption="assessmentType"
                    :name="'radioButtons'"
                    :getValue="onChangeRadio"
                />
            </b-col>
        </b-row>
        <div v-show="isAutoAssessment" class="forms" v-if="reload === false">
            <b-row>
                <b-col class="textfield-with">
                    <p>{{ $t('POLICY.RULE.POPUP.STEP2_DESC') }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div v-for="(cnd, cndIdx) in rule.cndVal" :key="cnd.tmpltId + cndIdx + reRenderKey">
                        <div class="select-connect" v-if="cnd.cjt !== null">
                            <select-box-single
                                :select-id="`select_conjunction_${cndIdx}`"
                                select-class="type-single size-s"
                                :select-box-options="constants.CONJUNCTION_OPTIONS"
                                :select-box-value="cnd.cjt"
                                :data-invalid="invalidRuleCtgLabel"
                                :use-translate="true"
                                @onSelectChange="cnd.cjt = $event.value"
                            />
                        </div>
                        <div class="select-detail-condition my-1">
                            <div class="actions"
                                 v-if="cnd.tmpltId !== 'new' || (cnd.tmpltId === 'new' && cndIdx > 0)">
                                <button type="button" class="buttons-icon" data-type="ghost"
                                        data-icon="delete" data-size="s"
                                        :title=" $t('COMMON.BUTTON.CAMEL.DELETE')" @click="delCnd(cndIdx)">
                                    {{ $t('COMMON.BUTTON.CAMEL.DELETE') }}
                                </button>
                            </div>
                            <!-- select condition -->
                            <div class="conditions custom-dropdown" v-if="cnd.tmpltId === 'new'">
                                <!-- Product Filter -->
                                <select-box-single
                                    :select-id="`elProdFltr_${cndIdx}`"
                                    :select-box-options="getprodFlterOptions"
                                    :select-box-value="prodDynamicVal"
                                    :data-invalid="prodDynamicInvalid"
                                    select-class="search type-single size-s"
                                    place-holder="POLICY.RULE.POPUP.SELECT_PRODUCT"
                                    :use-translate="true"
                                    before-text="PRODUCT."
                                    @onSelectChange="changeProduct"
                                />
                                <!-- Measure Filter -->
                                <select-box-single
                                    :select-id="`elMsrFltr_${cndIdx}`"
                                    :select-box-value="msrDynamicVal"
                                    :dynamic-value="prodDynamicVal"
                                    :select-box-options="msrFilterOptions"
                                    :use-translate="true"
                                    :use-dynamic="true"
                                    select-class="search type-single size-s"
                                    select-value="msr"
                                    select-text="msr"
                                    before-text="MEASURE."
                                    place-holder="POLICY.RULE.POPUP.SELECT_MEASURE"
                                    @onSelectChange="changeMeasure"
                                />
                                <!-- Condition Filter -->
                                <select-box-single
                                    v-if="msrDynamicVal !== ''"
                                    :dynamic-value="msrDynamicVal"
                                    :data-invalid="cndDynamicInvalid"
                                    :select-box-options="cndFilterMsrOptions"
                                    :select-id="`elCndFltr_${cndIdx}_1`"
                                    :use-translate="true"
                                    :use-dynamic="true"
                                    select-class="search type-single size-s"
                                    select-value="tmpltId"
                                    select-text="tmpltId"
                                    before-text="TEMPLATE."
                                    place-holder="POLICY.RULE.POPUP.SELECT_CONDITION"
                                    @onSelectChange="changeCondition"
                                />
                                <select-box-single
                                    v-else :select-id="`elCndFltr_${cndIdx}_2`"
                                    select-class="search type-single size-s"
                                    select-value="tmpltId"
                                    select-text="tmpltId"
                                    before-text="TEMPLATE."
                                    :use-translate="true"
                                    :use-dynamic="true"
                                    :dynamic-value="prodDynamicVal"
                                    :select-box-options="cndFilterOptions"
                                    place-holder="POLICY.RULE.POPUP.SELECT_CONDITION"
                                    :data-invalid="cndDynamicInvalid"
                                    @onSelectChange="changeCondition"
                                />
                                <p v-if="prodDynamicInvalid || cndDynamicInvalid" class="invalid-message">
                                    {{ $t('POLICY.RULE.INVALID.TEMPLATE_prod') }}
                                </p>
                            </div>
                            <!-- select detail -->
<!--                            implement check here-->
                            <div class="conditions" v-else-if="cnd.tmpltId !== 'new'">
                                <div v-for="(lang, index) in newTmplt[cndIdx][curLang].lang" :key="index">
                                    <template v-if="getCndDetailType(lang) === 'TEMPLATE_1'">
                                        <span :key="index">{{ lang['val'] }}</span>
                                    </template>

                                    <template v-else-if="getCndDetailType(lang) === 'TEMPLATE_2'">
                                        <InputBoxC
                                            :init-value="getPrpt(cnd, lang).val"
                                            :key="index"
                                            :inputKey="lang['val']"
                                            :inputId="`${cndIdx}_${index}`"
                                            :prpts="cnd.cnd.prpts"
                                            @onInputChange="cnd.cnd.prpts[lang['val']].val = $event.value;cnd.cnd.prpts[lang['val']].invalid = false; checkValidTemplateCondition()"
                                        />
                                    </template>

                                    <template v-else-if="getCndDetailType(lang) === 'TEMPLATE_3'">
                                        <InputBoxC
                                            :init-value="getPrpt(cnd, lang).val"
                                            @onInputChange="cnd.cnd.prpts[lang['val']].val = $event.value;cnd.cnd.prpts[lang['val']].invalid = false; checkValidTemplateCondition()"
                                            :inputKey="lang['val']"
                                            :inputId="`${cndIdx}_${index}`"
                                            :prpts="cnd.cnd.prpts"
                                            :key="`amount_${index}`"
                                        />
                                        <select-box-single
                                            :select-id="`cndInputSelect_${cndIdx}_${index}_${cnd.tmpltId}`"
                                            :key="`cycle_${index}`"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            select-class="type-single search size-s"
                                            use-translate="true"
                                            before-text="BASIC_FORMATION_UNIT."
                                            place-holder="POLICY.RULE.POPUP.SELECT_UNIT"
                                            select-text="key"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]; checkValidTemplateCondition()"/>
                                    </template>
                                    <!-- type, view 아닌 select. 그냥 표시해주면 됨. -->
                                    <template
                                        v-else-if="getCndDetailType(lang) === 'TEMPLATE_9'">
                                        <select-box-single
                                            :select-id="`cndSelect_${cndIdx}_${index}`"
                                            :key="index"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            select-class="type-single search size-s"
                                            use-translate="true"
                                            before-text="BASIC_FORMATION_UNIT."
                                            place-holder="POLICY.RULE.POPUP.SELECT_UNIT"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            select-text="key"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]; checkValidTemplateCondition()"/>
                                    </template>

                                    <template v-else-if="getCndDetailType(lang) === 'TEMPLATE_4'">
                                        <select-box-single
                                            :select-id="`cndSelectCfg_${cndIdx}_${index}`"
                                            :key="index"
                                            place-holder="POLICY.RULE.POPUP.SELECT_CONFIG"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            select-class="type-single search size-s"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]; checkValidTemplateCondition()"/>
                                    </template>

                                    <template v-else-if="getCndDetailType(lang) === 'TEMPLATE_5'">
                                        <select-box-single
                                            :select-id="`cndSelectRsrc_${cndIdx}_${index}`"
                                            :key="index"
                                            place-holder="POLICY.RULE.POPUP.SELECT_RESOURCE"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            select-class="type-single search size-s"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]; checkValidTemplateCondition()"/>
                                    </template>

                                    <!-- type 인 select. type 값에 templateTypeVal 변경해줘야 함. -->
                                    <template v-else-if="getCndDetailType(lang) === 'TEMPLATE_6'">
                                        <select-box-single
                                            :select-id="`cndSelectType_${cndIdx}_${index}`"
                                            :key="index"
                                            place-holder="POLICY.RULE.POPUP.SELECT_TYPE"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            select-class="type-single search size-s"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="rule.cndVal[cndIdx].cnd.prpts[lang['val']].slt=[$event.value];reRender();checkValidTemplateCondition()"></select-box-single>
                                    </template>

                                    <!-- view 인 select. view 값에 따라 templateTypeVal 변경해줘야 함. -->
                                    <template v-else-if="getCndDetailType(lang) === 'TEMPLATE_7'">
                                        <select-box-single
                                            :select-id="`cndSelectView_${cndIdx}_${index}`"
                                            :key="index"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            select-class="type-single search size-s"
                                            place-holder="POLICY.RULE.POPUP.SELECT_VIEW"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value];reRender(); checkValidTemplateCondition()"/>
                                    </template>
                                    <!-- svcGrp 인 select. view 값에 따라 templateTypeVal 변경해줘야 함. -->
                                    <template
                                        v-else-if="getCndDetailType(lang) === 'TEMPLATE_8'">
                                        <select-box-single
                                            :select-id="`cndSelectSvg_${cndIdx}_${index}`"
                                            :key="index"
                                            :select-box-value="getPrpt(cnd, lang).slt[0]"
                                            :use-dynamic="true"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :dynamic-value="cnd.cnd.prpts.view.slt[0]"
                                            select-class="type-single search size-s"
                                            place-holder="POLICY.RULE.POPUP.SELECT_GROUP"
                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value];reRender(); checkValidTemplateCondition()"/>
                                    </template>

                                    <!-- typeVal, svcGrp 아닌 multi-select. 그냥 표시해주면 됨. -->
                                    <template v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_13'">
                                        <select-box-multi
                                            :select-id="`cndMultiSelect_${cndIdx}_${index}`"
                                            :key="index"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value;checkValidTemplateCondition()"/>
                                    </template>

                                    <!-- typeVal, svcGrp 아닌 multi-select. 그냥 표시해주면 됨. -->
                                    <template v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_14'">
                                        <CSelectBoxMulti
                                            :select-id="`cndMultiSelect_${cndIdx}_${index}`"
                                            :key="index"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :isRequired="true"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value;checkValidTemplateCondition($event)"
                                        />
                                    </template>

                                    <!-- typeVal 인 multi-select. type 값에 따라 변경되어야 함. -->
                                    <template
                                        v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_10'">
                                        <select-box-multi
                                            :select-id="`cndMultiSelectTypeSvc_${cndIdx}_${index}`"
                                            :key="index"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            :use-dynamic="true"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :dynamic-value="cnd.cnd.prpts.type.slt[0]"
                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value; checkValidTemplateCondition()"/>
                                    </template>
                                    <template
                                        v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_17'">
                                        <CSelectBoxMulti
                                            :select-id="`cndMultiSelectTypeSvc_${cndIdx}_${index}`"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            :use-dynamic="true"
                                            :isRequired="true"
                                            :dynamic-value="cnd.cnd.prpts.type.slt[0]"
                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value; checkValidTemplateCondition()"/>
                                    </template>

                                    <!-- svcGrp 인 multi-select. view 값에 따라 변경되어야 함. -->
                                    <template
                                        v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_11'">
                                        <select-box-multi
                                            :select-id="`cndMultiSelectSvg_${cndIdx}_${index}`"
                                            :key="index"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :use-dynamic="true"
                                            :dynamic-value="cnd.cnd.prpts.view.slt[0]"
                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value; checkValidTemplateCondition()"/>
                                    </template>

                                    <template
                                        v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_16'">
                                        <CSelectBoxMulti
                                            :select-id="`cndMultiSelectSvg_${cndIdx}_${index}`"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :use-dynamic="true"
                                            :isRequired="true"
                                            :dynamic-value="cnd.cnd.prpts.view.slt[0]"
                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value; checkValidTemplateCondition()"/>
                                    </template>

                                    <template v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_12'">
                                        <select-box-multi
                                            :select-id="`cndSelectRsrcType_${cndIdx}_${index}`"
                                            :key="index"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            :data-invalid="getPrpt(cnd, lang).invalid"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value; checkValidTemplateCondition()"/>
                                    </template>
                                    <template v-else-if="getCndDetailType(lang, newTmplt[cndIdx]) === 'TEMPLATE_15'">
                                        <CSelectBoxMulti
                                            :select-id="`cndSelectRsrcType_${cndIdx}_${index}`"
                                            :placeHolder="$t('LABEL.SELECT')"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            :isRequired="true"
                                            :select-box-value="getPrpt(cnd, lang).slt"
                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value; checkValidTemplateCondition()"/>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <button type="button" class="buttons-add" @click="addCondition('and')">
                        {{ $t('POLICY.BUTTON.ADD_RULE') }}<!--측정 기준 추가--></button>
                </b-col>
            </b-row>
            <!-- 작업 설정 Area : Start -->
            <div class="select-action my-1" v-for="(actn, actnIdx) of rule.actnVal"
                :key="actn.actnId+actnIdx">
                <div class="actions"
                     v-if="actn.actnId !== null || actnIdx > 0 || rule.actnVal.length > 1">
                    <button type="button" class="buttons-icon" data-type="ghost" data-icon="delete"
                            data-size="s" title="삭제" @click="deleteAction(actnIdx)">
                        {{ $t('COMMON.BUTTON.CAMEL.DELETE') }}
                    </button>
                </div>
                <div class="action" v-if="showAlertSlct">
                    <select-box-single
                        :select-id="`actnSelect_${actnIdx}`"
                        :key="actnIdx"
                        :select-box-value="actn.actnId"
                        select-class="type-single size-s"
                        :select-box-options="actionOptions"
                        @onSelectChange="invalidActionValue = false; selectAction(actnIdx, $event.value)"
                        :data-invalid="invalidActionValue"
                        :use-translate="true"
                    />
                </div>
                <div>
                    <div class="conditions" v-if="actn.actnId === 'actn_email' && isAccessible(actn.actnId)">
                        <CVueSelect
                            :placeholder="$t('POLICY.RULE.ACTION.SELECT_RECIPIENT')"
                            :isMultiple="true"
                            :options="getUserListOptions"
                            :invalidText="$t('POLICY.RULE.INVALID.RECEIVER')"
                            :preset="getPreEmail(actn.trgt)"
                            @callGetValue="actn.trgt = getEmails($event)"
                        />
                    </div>
                    <div class="conditions actn-alert" v-else-if="actn.actnId === 'actn_alertnow' && isAccessible(actn.actnId)">
                        <div v-if="roleCode === constants.ROLE_CODE.ADMIN ||  roleCode === constants.ROLE_CODE.SERVICE_MANAGER">
                            <CVueSelect
                                placeholder="Select Action"
                                :options="alertOptions"
                                :disabled="alertOptions.length < 1"
                                @callGetValue="actn.trgt = getAlertOption($event.value)"
                                :preset="getPreAlert(actn.trgt)"
                                :isMultiple="false"
                                :isCloseOnSelect="true"
                            />
                        </div>
                        <div v-else>
                            <span>
                                <p class="invalid-message">{{$t('POLICY.RULE.ACTION.ALERT_PERMISSION')}}
                                    <br/>
                                    <a :href="urls.portalUrl+'/docs/alertnow/en/user-guide-alertnow-en.html'" style='text-decoration: underline;'>{{$t('POLICY.RULE.ACTION.ALERT_PERMISSION_URL')}}</a>
                                </p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 작업 설정 Area : End -->
            <button v-show="!disableAddTask" type="button" class="buttons-add" @click="addAction" :disabled="disableAddTask">
                {{ $t(`POLICY.BUTTON.ADD_TASK`) }}<!--작업 추가--></button>
            <b-row class="mt-5">
                <b-col>
                    <input type="checkbox" ref="eleActnExeYn" id="eleActnExeYn" name="eleActnExeYn"
                           class="checkbox"
                           :checked="rule.actnExeYn == null || rule.actnExeYn === constants.PARAM.SELECT.Y ? true : null"
                           @click="setActionExecutionYN">
                    <label for="eleActnExeYn">{{ $t('POLICY.RULE.ACTION_EXECUTION') }}
                        <!--다음 작업을 검사후 바로 실행합니다.--></label>
                </b-col>
            </b-row>
            <!--개선방법-->
            <b-row class="mt-5">
                <b-col>
                    <label class="textfield-with">{{ $t('POLICY.LABEL.REMEDIATION') }}<!--개선방법--></label>
                    <textarea
                        class="textarea"
                        :placeholder="$t('POLICY.RULE.INVALID.REMEDIATION')"
                        v-model="rule.transRemd"></textarea>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {BButton, BCol, BFormGroup, BFormRadio, BFormRadioGroup, BRow} from "bootstrap-vue";
import CSelectBoxMulti from "../../common/OptionSelect/CSelectBoxMulti.vue";
import CVueSelect from "../../common/OptionSelect/CVueSelect.vue"
import CSelectBoxSingle from "../../common/OptionSelect/CSelectBoxSingle.vue";
import BaseRadioButtons from "../../common/BaseRadioButtons.vue";
import InputBoxC from "../../common/InputBoxC.vue";
import _ from "lodash";

export default {
    name: "AddingRuleForm",
    components: {
        BFormGroup, BFormRadio, BFormRadioGroup, BRow, BCol, BButton,
        BaseRadioButtons, InputBoxC, CSelectBoxMulti, CVueSelect, CSelectBoxSingle
    },
    data() {
        return {
            showAlertSlct: true,
            reload: false,
            cndtList: {},
            cndtSize: 0,
            rule: {},
            msrDynamicVal: '',                // Measure 별 동적 필터 조건 값
            prodDynamicVal: '',               // Product 별 동적 필터 조건 값
            reRenderKey: 1,
            invalidRuleTitleMsg: "",          // Rule Title Invalid Message
            invalidRuleDesc: false,
            invalidRuleTitle: null,           // Rule Title 에 대한 invalid 구분
            invalidRuleCtgLabel: null,        // Rule Category 에 대한 invalid 구분
            invalidActionValue: false,
            isAutoAssessment: true,
            prodDynamicInvalid: false,        // Product 별 동적 필터 Validation check flag
            cndDynamicInvalid: false,         // Product 별 동적 필터 Validation check flag
            actionListBySelectedTemplate: [], // Condition 으로 선택할 수 있는 Action List
            assessmentType: 'auto',
            invalidActionEmailUser: false,
            isValidTemplateCondition: false,    // validate form condition
            disableAddTask: true,
            actionOptions: [],
            availableActions: [],
            slctedAcnt: "",
            ASSESSMENT_OPTIONS: [
                {item: 'manual', name: this.$t('POLICY.BUTTON.MANUAL_SCAN')},
                {item: 'auto', name: this.$t('POLICY.BUTTON.AUTO_SCAN')},
            ],
        }
    },
    props: {
        roleCode: String,
        alertOptions: {
            type: Array,
            default: ()=>{return []}
        },
        formType: Number,
        callChangeFormValidStat: Function,
        curLang: String,
        rawRule: Object,               // Popup 에서 control 될 Rule 정보
        newTmplt: Array,            // 사용되고있는 Template의 정보 리스트
        categoryList: Array,        // 회사에 등록되어있는 Category Label 정보 리스트
        actionTemplateList: Array,  // action 정보 리스트
        userList: Array,            // 회사에 가입되어있는 사용자 리스트 정보(Email 수신자 추가시 필요)
        callLoading: Function,
        callSetActionList: Function,
        callSelectProduct: Function,
        templateList: {
            type: Array,
            default: () => {
                return []
            }
        },
        conditionOptions: {
            type: Array,
            default: () => {
                return []
            }
        },
        msrOptions: {
            type: Array,
            default: () => {
                return []
            }
        },
        callSelectMsr: {
            type: Function,
            default: () => {
                return null;
            }
        },
    },
    watch: {
        "rule.transRemd"(value) {
            this.rule.remd = value;
        },
        isAutoAssessment(isAuto, olval) {
            if (isAuto) {
                this.checkValidTemplateCondition();
            } else {
                this.isValidTemplateCondition = true;
                this.changeFormValidStat();
            }
        },
        "rule.actnVal"(actions) {
            const emptyActn = _.find(this.rule.actnVal, actn => {return actn.actnId == null});
            if (emptyActn) {
                this.disableAddTask = true;
            } else {
                this.disableAddTask = false;
            }
        }
    },
    mounted() {
        document.getElementsByClassName("rule-select-ctg_1 selection multiple")[0].addEventListener("click", this.clickOnSelection);
        this.rule = this.bindRawRuleInfo(this.rawRule);
        this.checkProps();
        this.getSelectableActions();
    },
    computed: {
        getUserListOptions: function () {
            const userOptions = [];
            this.userList.forEach(function (u) {
                userOptions.push({key: u.userId, value: `${u.userNm} (${u.userEmail})`, email: u.userEmail})
            })
            return _.sortBy(userOptions, (user)=>{return user.email});
        },
        cndFilterMsrOptions: {
            get() {
                return _.groupBy(this.templateList, 'msr')
            },
            set: function (value) {
                //this.msrValue = null
                //this.msrDynamicVal = value
            }
        },
        msrFilterOptions: {
            get() {
                return _.groupBy(_.unionBy(this.templateList, 'msr'), 'prod');
            },
            set: function (value) {
                this.msrDynamicVal = '';
                this.prodDynamicVal = value;
                this.prodDynamicInvalid = false;
            }
        },
        prodFltrList: function () {
            return Object.keys(_.groupBy(this.templateList, 'prod')).sort();
        },
        getprodFlterOptions() {
            let options = [];
            let awsOpts = [];
            let azuOpts = [];
            let gcpOpts = [];
            if (this.templateList && this.prodFltrList) {
                self = this;
                this.prodFltrList.forEach((product) => {
                    const template = _.find(self.templateList, (tmpl) => {
                        return (tmpl.prod.toLowerCase() === product.toLocaleLowerCase());
                    });
                    const templateVal = _.split(product, "_")[1];
                    let item = {};
                    item.key = product;
                    item.name= this.$t(`PRODUCT.${templateVal}`),
                    item.val = templateVal;
                    item.dataIcon = this.Common.getVendorByKey(template.vendor);
                    if (item.dataIcon === 'aws') {
                        awsOpts.push(item);
                    } else if (item.dataIcon === 'azure') {
                        azuOpts.push(item);
                    } else if (item.dataIcon === 'gcp') {
                        gcpOpts.push(item);
                    } else {
                        options.push(item);
                    }
                })
            }
            awsOpts = _.sortBy(awsOpts, (opt)=>{return opt.name});
            azuOpts = _.sortBy(azuOpts, (opt)=>{return opt.name});
            gcpOpts = _.sortBy(gcpOpts, (opt)=>{return opt.name});

            options = options.concat(awsOpts);
            options = options.concat(azuOpts);
            options = options.concat(gcpOpts);
            return options;
        },
        cndFilterOptions: {
            get() {
                let options = _.sortBy(this.templateList, (tmpl)=>{return tmpl.titl})
                options = _.groupBy(options, 'prod')
                return options
            },
            set(value) {
                this.msrDynamicVal = '';
                this.prodDynamicVal = value;
                this.prodDynamicInvalid = false;
            }
        },
        getCtgFilterOptions: function () {
            let ctgFilter = []
            this.categoryList.forEach(function (r) {
                ctgFilter.push({key: r.ctgId, val: r.ctgLabel})
            });
            return ctgFilter;
        },
    },
    methods: {
        getSelectableActions() {
            const selectableActionList = [];
            selectableActionList.push({key: '', val: 'POLICY.RULE.ACTION.NONE'})

            if (this.rule.actnVal.length === 1) {
                selectableActionList.push({
                    key: this.constants.PARAM.SELECT.NONE,
                    val: 'POLICY.RULE.POPUP.SELECT_NONE'
                })
            }

            this.actionListBySelectedTemplate = this.actionTemplateList.filter((actn) => {
                    return actn.prod == 'default' && actn.trgtYn == 'Y';
            });

            for (let actionTemplate of this.actionListBySelectedTemplate) {
                selectableActionList.push({
                    key: actionTemplate.actnId,
                    val: 'POLICY.RULE.ACTION.' + actionTemplate.actnId
                });
            }

            this.actionOptions = _.clone(selectableActionList);
            this.availableActions = selectableActionList;

            if (this.formType != 0 && this.rule.actnVal) { //NEW: 0, EDIT: 1, COPY: 2
                const ruleActions = this.rule.actnVal;
                const hasAlertEmail = ruleActions.find((actn)=>{return actn.actnId == "actn_email"});
                const hasAlertNow = ruleActions.find((actn) => { return actn.actnId == "actn_alertnow" });
                if (hasAlertEmail) {
                    this.slctedAcnt = "actn_email";
                } else if (hasAlertNow) {
                    this.slctedAcnt = "actn_alertnow";
                }
                this.limitAction();
            }
        },
        handleActionSelect(actionType) {
            this.slctedAcnt = actionType;
            this.disableAddTask = false;
        },
        // getPreAlert(keys) {
        //     if(keys) {
        //         return _.filter(this.alertOptions, (t)=>{return keys.includes(t.unqKey)});
        //     }
        // },
        getPreAlert(keys) {
            return this.alertOptions.find(opt=>opt.key === keys[0]);
        },
        getPreEmail(userIds) {
            return this.getUserListOptions.filter(user => userIds.includes(user.key));
        },
        getActionTrigger(action) {
            return action.trgt;
        },
        // getAlertOption(selectedValue) {
        //     if (selectedValue.map) {
        //         return selectedValue.map((obj)=>{return obj.key});
        //     }
        // },
        getAlertOption(selectedValue) {
            const opt = [];
            opt.push(selectedValue.key);
            return opt;
        },
        isAccessible(actionId) {
            const action = this.actionTemplateList.find(function(o) { return o.actnId == actionId; });
            if (action && action.trgtYn === this.constants.PARAM.SELECT.Y) {
                return true;
            }
            return false;
        },
        getEmails(selectedValue) {
            const keys = selectedValue.value.map((e)=>{return e.key})
            if (keys.length === 0) {
                this.invalidActionEmailUser = true;
            } else {
                this.invalidActionEmailUser = false;
            }
            return keys;
        },
        setCndSlct(condition, lang, e) {
            condition.cnd.prpts[lang['val']].slt = [e.value];
            this.reload = true;
            if (e.value && e.value.length > 0) {
                condition.cnd.prpts[lang['val']].invalid = false;
            } else {
                condition.cnd.prpts[lang['val']].invalid = true;
            }
            if (condition.tmpltId === 'OPTR_EC2_RUNNING' && lang['val']==='type') {
                condition.cnd.prpts['typeVal'].slt = [];
                this.$nextTick(function () {
                    this.reload = false;
                    this.checkValidTemplateCondition();
                });
            } else {
                this.reload = false;
                this.checkValidTemplateCondition();
            }
        },
        setCndInput(condition, lang, e) {
            condition.cnd.prpts[lang['val']].val = e.value;
            if (e.value && e.value.length > 0) {
                condition.cnd.prpts[lang['val']].invalid = false;
            } else {
                condition.cnd.prpts[lang['val']].invalid = true;
            }
            this.checkValidTemplateCondition();
        },
        getPrpt(cnd, lang) {
            return cnd.cnd.prpts[lang['val']];
        },
        getCndDetailType(lang, template) {
            // for debug and development purposes
            const key = lang['key'];
            const val = lang['val'];
            let type = "";
            switch (key) {
                case 'text':
                    type = "TEMPLATE_1";
                    break;
                case 'input':
                    type = 'TEMPLATE_2'
                    break;
                case 'input-select':
                    type = 'TEMPLATE_3'
                    break;
                case 'select':
                    if (val === 'cfg') {
                        type = "TEMPLATE_4";
                    } else if (val === 'rsrc') {
                        type = "TEMPLATE_5";
                    } else if (val === 'type') {
                        type = "TEMPLATE_6";
                    } else if (val === 'view') {
                        type = "TEMPLATE_7";
                    } else if (val === 'svcGrp') {
                        type = "TEMPLATE_8";
                    } else {
                        type = "TEMPLATE_9";
                    }
                    break;
                case 'multi-select':
                    if (val === 'typeVal') {
                        type = "TEMPLATE_10";
                        if (template) {
                            switch (template.tmpltId) {
                                case "OPTR_RDS_RUNNING":
                                    type = "TEMPLATE_17";
                                    break;
                            }
                        }
                    } else if (val === 'svcGrp') {
                        type = "TEMPLATE_11";
                        if (template) {
                            switch (template.tmpltId) {
                                case "OPTR_EC2_START_SCHD":
                                case "OPTR_EC2_STOP_SCHD":
                                    type = "TEMPLATE_16";
                                    break;
                            }

                        }
                    } else if (val === 'rsrcType') {
                        type = "TEMPLATE_12";
                        if (template) {
                            switch (template.tmpltId) {
                                case "PERF_ALL_UNTAG":
                                    type = "TEMPLATE_15"
                                    break;
                            }
                        }
                    } else {
                        type = "TEMPLATE_13";
                        if (template) {
                            switch (template.tmpltId) {
                                case "PERF_AWS_VALUELESS_RESOURCE":
                                case "PERF_AZU_VALUELESS_RESOURCE":
                                case "PERF_GCP_VALUELESS_RESOURCE":
                                case "SECR_ACTIVITY_LOG_ALERT_EXISTS":
                                    type = "TEMPLATE_14"
                                    break;
                            }
                        }
                    }
                    break;
            }
            // console.log("input type: " + key + " template " + type);
            return type;
        },
        clickOnSelection(e) {
            const firstChildNode = _.get(e, "target.firstChild.nodeName");
            if (firstChildNode === "SELECT") {
                const target = document.getElementsByClassName("menu transition")[0];
                const select = document.getElementsByClassName("rule-select-ctg_1 selection dropdown")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");

                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            }
        },
        bindRawRuleInfo(rawRule) {
            let rule = _.cloneDeep(rawRule);
            const {isEmptyObject, isEmptyText} = this.Common;
            if (!isEmptyObject(rawRule)) {
                const remd = rawRule[`${this.curLang}RuleRemd`];
                const desc = rawRule[`${this.curLang}RuleDesc`];
                const titl = rawRule[`${this.curLang}RuleTitle`];
                rule.transRemd = isEmptyText(remd) ? rawRule.remd : remd;
                rule.transDesc = isEmptyText(desc) ? rawRule.desc: desc;
                rule.transTitl = isEmptyText(titl) ? rawRule.titl : titl;
            }
            return rule;
        },
        changeFormValidStat() {
            this.callChangeFormValidStat(this.invalidRuleTitle === false && this.invalidRuleCtgLabel === false && this.isValidTemplateCondition);
        },
        checkValidTemplateCondition(event) {
            const tmplId = _.get(this.rule, 'cndVal[0].tmpltId', null);
            if (tmplId === 'new') {
                this.callChangeFormValidStat(false);
            } else {
                if (event && event.isInvalid) {
                    this.isValidTemplateCondition = false;
                    this.changeFormValidStat();
                } else {
                    const invalidCndt = this.isInvalidCondition();
                    const invalidAcnt = this.isInvalidActionValue();
                    const invalidTmplt = this.isInvalidTemplate();
                    this.isValidTemplateCondition = (!invalidCndt && !invalidAcnt && !invalidTmplt);
                    this.changeFormValidStat();
                }
            }
        },
        // 전체 Condition 의 value 검사
        // Target 이 있는 Action 에 대해서 Value 값 입력 유효성 검사
        isInvalidActionValue() {
            const self = this;
            for (const actn of this.rule.actnVal) {
                for (const actnTmplt of self.actionTemplateList) {
                    if (actn.actnId === actnTmplt.actnId) {
                        this.invalidActionEmailUser = actnTmplt.trgtYn === (this.constants.PARAM.SELECT.Y && actn.trgt.length < 1);
                        break;
                    }
                }
                if (_.filter(this.rule.actnVal, {actnId: actn.actnId}).length > 1) {
                    this.invalidActionValue = true;
                }
                if (this.invalidActionValue || this.invalidActionEmailUser) {
                    break;
                }
            }
            return this.invalidActionValue || this.invalidActionEmailUser;
        },
        isInvalidCondition() {
            for (let cond of this.rule.cndVal) {
                const properties = _.get(cond, "cnd.prpts")
                if (properties) {
                    let keySet = Object.keys(properties)
                    for (let key of keySet) {
                        if (key === this.constants.TEMPLATE_PROPERTIES.CURRENCY ||
                            key === this.constants.TEMPLATE_PROPERTIES.TIME ||
                            key === this.constants.TEMPLATE_PROPERTIES.NUMBER ||
                            key === this.constants.TEMPLATE_PROPERTIES.PERCENT) {
                            if (this.Common.isEmptyText(properties[key].val) || this.Common.validNumber(cond.cnd.prpts[key].val)) {
                                return true;
                            }
                        } else if (key === this.constants.TEMPLATE_PROPERTIES.AWS_CONFIG ||
                            key === this.constants.TEMPLATE_PROPERTIES.TAG ||
                            key === this.constants.TEMPLATE_PROPERTIES.TYPE_VAL) {
                            if (properties[key].slt.length < 1 || properties[key].invalid) {
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        },
        checkProps() {
            const {FORM_TYPE} = this.constants;
            if (this.formType === FORM_TYPE.EDIT ||
                this.formType === FORM_TYPE.COPY) {
                const cndVal = _.get(this.rule, "cndVal[0].tmpltId");
                if (cndVal && cndVal !== "new") {
                    this.isAutoAssessment = true;
                    this.assessmentType = this.ASSESSMENT_OPTIONS[1].item;
                } else {
                    this.isAutoAssessment = false;
                    this.assessmentType = this.ASSESSMENT_OPTIONS[0].item;
                    this.rule.cndVal.push({
                        'tmpltId': 'new',
                        'cjt': null,
                        'cnd': {
                            'cjt': null
                        }
                    });
                }
                if (this.rule.actnVal.length === 0) {
                    this.addAction();
                    this.disableAddTask = true;
                }
                this.invalidRuleTitle = false;
                this.invalidRuleCtgLabel = false;
                this.isValidTemplateCondition = true;
                this.changeFormValidStat();
            }
        },
        changeProduct(e) {
            this.prodDynamicInvalid = false;
            this.cndDynamicInvalid = false;
            this.msrFilterOptions = e.value;
        },
        changeMeasure(e) {
            this.cndDynamicInvalid = false;
            this.msrDynamicVal = e.value;
        },
        changeCondition(e) {
            this.cndDynamicInvalid = false;
            this.selectTemplate(e);
        },
        groupType(item) {
            this.checkValidTemplateCondition();
            return _.groupBy(_.unionBy(item, 'key'), 'upType');
        },
        setActionExecutionYN() {
            this.rule.actnExeYn = this.$refs.eleActnExeYn.checked ? this.constants.PARAM.SELECT.Y : 'N';
        },
        delCnd: function (cndIdx) {
            // Condition 삭제
            // cndIdx : 삭제할 Condition Index
            this.prodDynamicInvalid = false
            this.rule.cndVal.splice(cndIdx, 1);
            this.newTmplt.splice(cndIdx, 1);

            // Condition 삭제했을 때도 ActionList 다시 세팅
            this.callSetActionList(this.newTmplt);
            if (this.rule.cndVal.length === 0) {
                this.rule.cndVal.push({
                    'tmpltId': 'new',
                    'cjt': null,
                    'cnd': {
                        'cjt': null
                    }
                });
            } else {
                this.rule.cndVal[0].cjt = null;
            }
            this.checkValidTemplateCondition();
        },
        selectTemplate: function (event) {
            const length = this.rule.cndVal.length;
            const idx = length - 1;
            let selectedTemplate = _.cloneDeep(_.find(this.templateList, {'tmpltId': event.value})) // cloneDeep 이 없으면 동일한 template 두 번 선택했을 때 이미 object 로 바껴있는 애라고 에러남
            // template 세팅 및 저장 obj 에 template ID 세팅 및 조건 배열 초기화
            this.newTmplt.push(selectedTemplate);
            // Action 세팅 및 저장할 obj 에 action ID 세팅
            this.callSetActionList(this.newTmplt);

            // Condition 에 Template ID 세팅
            this.rule.cndVal[idx].tmpltId = selectedTemplate.tmpltId;
            // 새 Sub condition 배열, 객체 세팅
            this.rule.cndVal[idx].cnd = {
                'cjt': null,
                'prpts': {}
            };
            // cond 에 properties 세팅
            for (let key in selectedTemplate.basicFormation.cnd) {
                if (key.toLowerCase() !== 'cjt') {
                    this.rule.cndVal[idx].cnd.prpts[key] = {
                        'val': selectedTemplate.basicFormation.cnd[key].val,
                        'slt': selectedTemplate.basicFormation.cnd[key].slt
                    };
                }
            }
            if (!selectedTemplate.basicFormation.cjtOfActn) {
                this.checkValidTemplateCondition();
            }
            // console.log("selecte Template: " + event.value);
        },
        changeCategory(e) {
            this.rule.ctgLabel = e.value;
            this.invalidRuleCtgLabel = this.rule.ctgLabel.length < 1;
            this.checkValidTemplateCondition();
        },
        changeSeverity(e) {
            this.rule.svrty = e.value;
        },
        changeTitle(e) {
            this.rule.titl = e.target.value;
        },
        changeDescription(e) {
            this.rule.desc = e.target.value;
            this.isInvalidRuleDesc();
        },
        // Rule Desc 유효성 검사
        isInvalidRuleDesc() {
            // this.Common.isEmptyText(this.rule.desc)
            this.invalidRuleDesc = (this.rule.desc && this.rule.desc.length > 4000);
            return this.invalidRuleDesc;
        },
        // Rule Title 유효성 검사
        checkRuleTitle() {
            if (this.Common.isEmptyText(this.rule.titl)) {
                this.invalidRuleTitle = true;
                this.invalidRuleTitleMsg = this.$t('POLICY.RULE.INVALID.TITLE');
            } else if (this.rule.titl.length > 100) {
                this.invalidRuleTitle = true;
                this.invalidRuleTitleMsg = this.$t('SETTING.WHITELIST.ERROR.MAX', {'cnt': 200});
            } else {
                this.invalidRuleTitle = false;
            }
            this.changeFormValidStat();
        },
        // implement template validtion for all templates
        isInvalidTemplate() {
            const conditions = this.rule.cndVal;
            if (!conditions) return false;
            const i = this.rule.cndVal.length - 1;
            let isInvalid = false;
            // 마지막 rule.cndVal 의 tmpltId 가 null 이면 규칙 추가 해놓고 조건 선택 안 함..
            if (conditions[i].tmpltId === 'new') {
                this.prodDynamicInvalid = this.prodDynamicVal === '' || this.prodDynamicVal === -1
                this.cndDynamicInvalid = true
                isInvalid = true
            }
            conditions.forEach(cndt=>{
                const prop = _.get(cndt, 'cnd.prpts', null);
                if (prop) {
                    switch (cndt.tmpltId) {
                        case 'COST_ALL_SPEND':
                        case 'COST_AZR_ALL_SPEND':
                            if ( this.Common.isEmptyText(prop.cur.val) ||
                                this.Common.isEmptyText(prop.time.val) ||
                                prop.svcGrp.slt.length < 1 ||
                                prop.view.slt.length < 1 ) {
                                isInvalid = true;
                            }
                            break;
                        case 'SECR_EC2_SECR_GRP_ACS':
                        case 'SECR_SECTGRP_UN_RESTRICT':
                            // A valid port value is between 0 and 65535.
                            // A port number of zero will let the system pick up an ephemeral port in a bind operation.
                            const port = prop.port.val;
                            if (this.Common.isEmptyText(port) ||
                                !(port > 0) ||
                                !(port <= 65535)
                            ) {
                                isInvalid = true;
                            }
                            break;
                        case 'PERF_AWS_VALUELESS_RESOURCE':
                        case 'PERF_GCP_VALUELESS_RESOURCE':
                        case 'PERF_AZU_VALUELESS_RESOURCE':
                        case 'SECR_ACTIVITY_LOG_ALERT_EXISTS':
                        case 'OPTR_EC2_START_SCHD':
                        case 'OPTR_EC2_STOP_SCHD':
                        case 'PERF_ALL_UNTAG':
                            const keys = Object.keys(prop);
                            keys.forEach(key => {
                                if (prop[key].slt.length < 1) {
                                    isInvalid = true;
                                }
                            })
                            break;
                    }
                }
            });
            return isInvalid;
        },
        addCondition: function (cjt) {
            // Condition 추가
            // cjt : 추가할 Condition Conjunction
            if (!this.isInvalidTemplate()) {
                this.rule.cndVal.push({
                    'tmpltId': 'new',
                    'cjt': cjt,
                    'cnd': {
                        'cjt': null
                    }
                });
            }
            // 템플릿 선택 필터값 초기화
            this.prodDynamicVal = '';
            this.prodDynamicInvalid = false;
            this.cndDynamicInvalid = false;
            this.callChangeFormValidStat(false);
        },
        getRuleInfo() {
            this.ruleInfo = {
                ...this.ruleInfo,
                radioButtons: this.assessmentType,
                ruleDetail: this.rule
            }
            return this.ruleInfo;
        },
        onChangeRadio(label, value) {
            if (label === 'radioButtons') {
                this.isAutoAssessment = value === "auto";
            }
            this.assessmentType = value;
        },
        // Action 선택
        selectAction(actnIdx, actnId) {
            const obj = this.rule.actnVal[actnIdx];
            // actnId 세팅
            obj.actnId = actnId;
            // 선택한 Action 이 trgtYN Y 이면 trgt array 넣어줌. 근데 지금 Target 있는 게 Email 밖에 없다고 한다
            for (const actnTmplt of this.actionTemplateList) {
                if (actnTmplt.actnId === actnId &&
                    actnTmplt.trgtYn === this.constants.PARAM.SELECT.Y) {
                    obj.trgt = [];
                }
            }
            this.handleActionSelect(actnId);
            this.limitAction();
        },
        // Action 추가
        limitAction() {
            this.showAlertSlct = false,
            this.$nextTick(function () {
                const actionType = this.slctedAcnt;
                if (actionType === "actn_email") {
                    _.remove(this.actionOptions, actn => {return actn.key == "actn_alertnow"});
                } else if (actionType === "actn_alertnow") {
                    _.remove(this.actionOptions, actn => {return actn.key == "actn_email"});
                    this.disableAddTask = true;
                }
                this.showAlertSlct = true;
            });
        },
        addAction() {
            // this.limitAction();
            this.rule.actnVal.push({
                "actnId": null
            });
        },
        // Action 삭제
        deleteAction: function (actnIdx) {
            const actnVal = this.rule.actnVal;
            actnVal.splice(actnIdx, 1);
            this.$nextTick(function () {
                if (actnVal.length === 0) {
                    this.addAction();
                    this.disableAddTask = true;
                    this.actionOptions = _.clone(this.availableActions);
                }
            });
        },
        reRender: function () {
            this.reRenderKey++;
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .go-vendor.ui.selection.dropdown.rule-select-ctg_1 {
    width: 100% !important;
}

/deep/ .go-vendor.ui.data-invalid.selection.dropdown.type-tagging {
    border-color: red;
}

/deep/ .go-vendor.ui.selection.dropdown.type-tagging {
    width: 275px;
}

/deep/ .popout-layer .go-vendor.ui.selection.dropdown {
    width: 93%;
}
/deep/ .select-action .conditions .go-vendor.ui.selection.dropdown .menu,
/deep/ .custom-dropdown .go-vendor.ui.selection.dropdown .menu {
    width: 300px !important;
}

/deep/ .custom-dropdown .go-vendor.ui.selection.dropdown .menu .item {
    white-space: normal !important;
}

/deep/ .base-radio input[type=radio] {
    height: 15px;
    width: 15px;
    appearance: auto;
    margin: 8px;
}

/deep/ .base-radio .custom-control-inline {
    display: inline-block;
    margin: 8px;
}
/deep/ .base-radio .custom-control-inline label span {
    vertical-align: inherit;
}
/deep/ .conditions.custom-dropdown {
    padding-top: 12px;
}

/deep/ a.ui.label.transition.visible {
    height: auto !important;
}

/deep/ .select-detail-condition .actions,
.select-action .actions {
    align-items: center;
    padding: 4px;
    width: 33px;
}
/deep/ .select-action .action {
    min-width: 103px;
}

/deep/ .select-detail-condition .conditions {
    padding: 8px 18px;
}

/deep/ .actn-alert .multiselect__select {
    z-index: 1;

}
/deep/ .actn-alert span.multiselect__single {
    font-size: 0.8rem;
    margin: 0 -1px 0 0;
    padding-right: 20px;
}

/deep/ .actn-alert .multiselect .multiselect__tags {
    min-width: 120px;
    padding: 1px;
}

/deep/ button:hover {
    background-color: aliceblue;
}

/deep/ button:disabled {
    background-color: inherit;
    cursor: default;
}

/deep/ .multiselect__select:before {
    top: 80%;
}

/deep/ .actn-alert .multiselect__placeholder {
    padding: 3px;
}

/deep/ .actn-alert .multiselect__tags-wrap {
    margin-right: 10px;
    display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyComponents/AddingRuleForm.vue